import { RootState } from "../rootStore";

export const selectCurrentClinicianList = ({ currentClinician }: RootState) =>
  currentClinician.cliniciansList;

export const selectClinicStats = ({ currentClinician }: RootState) =>
  currentClinician.clinicStats;

export const selectClinicRecoveryTemplates = ({
  currentClinician,
}: RootState) => currentClinician.clinicRecoveryTemplates;

export const selectCurrentRecoveryTemplate = ({
  currentClinician,
}: RootState) => currentClinician.selectedRecoveryTemplate;

export const selectCurrentClinicTeamMembersList = ({
  currentClinician,
}: RootState) => currentClinician.clinicTeamMembers;

export const selectCurrentClinicTeamLeadsList = ({
  currentClinician,
}: RootState) => currentClinician.clinicTeamLeads;

export const selectCurrentClinicTeamMembersStringList = ({
  currentClinician,
}: RootState) => currentClinician.clinicTeamMembersString;
export const selectCurrentClinicianPatients = ({
  currentClinician,
}: RootState) => currentClinician.clinicianPatientsList;

export const selectClinicianHasMorePatients = ({
  currentClinician,
}: RootState) =>
  currentClinician.totalPatients >
  currentClinician.offsetPatients + currentClinician.limitPatients;

export const selectPatientsTotal = ({ currentClinician }: RootState) =>
  currentClinician.totalPatients;

export const selectPatientsOffset = ({ currentClinician }: RootState) =>
  currentClinician.offsetPatients;

export const selectPatientsLimit = ({ currentClinician }: RootState) =>
  currentClinician.limitPatients;

export const selectClinicHasMoreClinicians = ({
  currentClinician,
}: RootState) =>
  currentClinician.total > currentClinician.offset + currentClinician.limit;

export const selectSortConfig = ({ currentClinician }: RootState) =>
  currentClinician.sortConfig;

export const selectSortConfigClinicianPatients = ({
  currentClinician,
}: RootState) => currentClinician.sortConfigPatients;

export const selectSelectedClinician = ({ currentClinician }: RootState) =>
  currentClinician.selectedClinician;

export const selectSelectedClinicianRoles = ({ currentClinician }: RootState) =>
  currentClinician.selectedClinicianRoles;

export const selectCurrentClinician = ({ currentClinician }: RootState) =>
  currentClinician.currentClinician;

export const selectCurrentClinicianLoading = ({
  currentClinician,
}: RootState) => currentClinician.loading;

export const selectCurrentClinicianPatientsLoading = ({
  currentClinician,
}: RootState) => currentClinician.clinicianPatientsLoading;

export const selectClinicianUpdateAvatarLoading = ({
  currentClinician,
}: RootState) => currentClinician.updateAvatarLoading;

export const selectClinicUsersOffset = ({ currentClinician }: RootState) =>
  currentClinician.offset;

export const selectClinicUsersTotal = ({ currentClinician }: RootState) =>
  currentClinician.total;

export const selectClinicUsersLimit = ({ currentClinician }: RootState) =>
  currentClinician.limit;
